var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('span',{key:item.id,class:[_vm.j_id == item.id ? 'active fl name' : 'fl name'],on:{"click":function($event){return _vm._setjob(item.id)}}},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }